const guiColors = {
    'motion-primary': '#2d2dd3',
    'motion-primary-transparent': 'hsla(240, 65%, 50%, 0.35)',
    'motion-tertiary': 'hsla(240, 65%, 30%, 1)',
    'motion-primary-dark': 'hsla(240, 65%, 40%, 1)',
	
	'looks-secondary': '#2d2dd3',
    'looks-secondary-light': '#6565fa',
    'looks-secondary-lighter': '#9393fb',
    'looks-transparent': 'hsla(240, 65%, 50%, 0.35',
    'looks-light-transparent': 'hsla(240, 100%, 50%, 0.15)',
    'looks-secondary-dark': '#2424a9',
    'looks-secondary-darker': '#161672',
    'looks-secondary-deep-dark': '#0f0f42',

    'extensions-primary': 'hsla(240, 91%, 53%, 1)',
    'extensions-tertiary': 'hsla(240, 80%, 43%, 1)',
    'extensions-transparent': 'hsla(240, 91%, 53%, 0.35)',
    'extensions-light': 'hsla(240, 80%, 43%, 1)',

    'drop-highlight': 'hsla(240, 100%, 77%, 1)'
};

const blockColors = {
    checkboxActiveBackground: 'hsla(240, 65%, 50%, 1)',
    checkboxActiveBorder: '#5b5788'
};

export {
    guiColors,
    blockColors
};